(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    (function () {

  function initFestiveLogos() {

    const festiveLogos = document.querySelectorAll(
      '.header-logo--festive[data-festive-enabled="true"]'
    );

    festiveLogos.forEach(function (logo) {

      if (logo.dataset.festiveInitialized === 'true') {
        return;
      }

      logo.dataset.festiveInitialized = 'true';

      const playMode = logo.dataset.festivePlayMode;

      const shouldReturn =
        logo.dataset.festiveReturn === 'true';

      const returnDelay = parseInt(
        logo.dataset.festiveReturnDelay || '4000',
        10
      );


      /* =====================================================
         ONCE PER SESSION
         ===================================================== */

      if (playMode === 'once_session') {

        try {

          const sessionKey =
            'sohum_festive_logo_played';

          if (sessionStorage.getItem(sessionKey)) {
            return;
          }

          sessionStorage.setItem(
            sessionKey,
            'true'
          );

        } catch (error) {

          /* Continue animation if storage is unavailable */

        }
      }


      /* =====================================================
         START ANIMATION
         ===================================================== */

      requestAnimationFrame(function () {

        setTimeout(function () {

          logo.classList.add(
            'header-logo--festive-active'
          );

        }, 50);

      });


      /* =====================================================
         RETURN TO NORMAL
         ===================================================== */

      if (shouldReturn) {

        setTimeout(function () {

          logo.classList.add(
            'header-logo--return-normal'
          );

          setTimeout(function () {

            logo.classList.remove(
              'header-logo--festive-active'
            );

            logo.classList.remove(
              'header-logo--return-normal'
            );

          }, 800);

        }, returnDelay);

      }

    });

  }


  /* =======================================================
     INITIAL PAGE LOAD
     ======================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initFestiveLogos
    );

  } else {

    initFestiveLogos();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    initFestiveLogos
  );

})();
  } catch(e) { console.error(e); }
})();

})();
